<template>
    <div class="col-lg-12 d-flex flex-column">
        <div class="col-12 pb-5 mb-4" v-if="pageloader">
            <img src="../../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
        </div>
        <div v-if="!pageloader" class="pb-5">
            <div class="row no-gutters pb-5" v-if="ProductVideosList.length === 0">
                <div class="col-12 card mb-4 introvideocard">
                    <div class="row no-gutters p-2" >
                        <div class="col p-5 text-center">
                        <img src="../../assets/no_video.svg" class="img-md-fluid img-sm-fluid no-video mx-auto pb-4" alt="novideo">
                        <div class="col d-flex justify-content-center fontsize16 black60 proximanova">No Video's Found</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="ProductVideosList.length>0">
                <div v-for="(product,index) in ProductVideosList" :key="index">
                    <div class="card mb-2  mt-lg-2" :id="'companyProductVideoCardItem'+index">
                        <div class="card-body homevideoslist" >
                            <div class="d-flex flex-column">
                                <div class="videocardhead d-flex justify-content-between p-3">
                                    <div class="d-flex" >
                                        <div class="d-flex flex-column pl-2 pr-2 mt-0 text-capitalize">
                                            <span class="fontsize14 black proximanova-semibold nameBlock" >Product Video</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="videocardbody">
                                    <div class="col-12   productvideocard">
                                        <div >
                                            <video height="320" oncontextmenu="return false" :src="product.productVideoLink" controlsList="nodownload"  :id="'productVideo'+index" > </video>
                                        </div>
                                        <div class="card-img-overlay ">
                                            <!-- <div class="mt-3">
                                                <img src="../../assets/Play_Icon.svg" v-if="!product.playingProductVideo" class="playpausevideobtn" alt="" @click="playProductVideo(index)" alt="playvideo">
                                                <img src="../../assets/Pausevideo.svg" class="playpausevideobtn" v-if="product.playingProductVideo" alt="" @click="playProductVideo(index)" alt="pausevideo">
                                            </div> -->
                                            <div class="row no-gutters mb-3 ml-0 mr-0 pb-3 companyvid_overlay1">
                                                <div class="p-3 black_overlay_height ml-3 d-flex flex-column"></div>
                                            </div>
                                            <div class="mt-3 mx-auto">
                                                <img src="../../assets/play_video.svg" v-if="!product.playingProductVideo" class="playpausevideobtn" alt="playvideo" @click="playProductVideo(index, product)">
                                                <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="product.playingProductVideo && product.replayVideo">
                                                    <img src="../../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayfollowerVideo(index, product)">
                                                </div>
                                                <div class="replaybtn1 shadow" title="replay video" id="playvideobtn" v-if="product.playingProductVideo && product.loadingVideo">
                                                    <img src="../../assets/video_loading.gif" class="replayicon1 mx-auto" alt="videoloading">
                                                </div>
                                                <img src="../../assets/Pausevideo.svg" class="playpausevideobtn pausebtn" v-if="product.playingProductVideo && !product.replayVideo && !product.loadingVideo" alt="pausevideo" @click="playProductVideo(index, product)">
                                            </div>
                                            <div class="bottom">
                                                <div class="companyvid_overlay2">
                                                    <div class="p-3 black_overlay_height ml-3 d-flex flex-column"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="postvideocontent p-1 pb-2 pl-3 d-flex justify-content-between">
                                    <div class="d-flex flex-column pl-2 descript-section">
                                        <span class="proximanova-semibold fontsize16 black80 text-capitalize">{{product.productVideoTitle}}</span>
                                        <span class="proximanova black60 fontsize14 flex-wrap" v-if="product.productVideoDescription">{{product.productVideoDescription}}</span>
                                    </div>
                                </div>
                                <div class="pb-3">

                                    <div class="row no-gutters">
                                        <div class="col-4 d-flex justify-content-center flex-column p-3 ml-md-4 pr-2 mt-0 productImgcard">
                                            <img :src="product.productPictureLink" class="mx-auto  productImg" alt="productimg">
                                        </div>
                                        <div class="col-7 d-flex justify-content-center flex-column p-3 ml-4 pr-2 mt-0 ">
                                            <div class="d-flex flex-column text-capitalize">
                                              <span class="font16-opacity30 proximanova ml-1" >Product Details</span>
                                            </div>
                                            <div class="d-flex flex-column mt-1 text-capitalize">
                                              <span class="font20-bold proximanova ml-1" >{{product.productName}}</span>
                                            </div>
                                            <div class="d-flex flex-column text-capitalize">
                                              <span class="fontsize14 black80 proximanova ml-1" >{{product.productVideoDescription}}</span>
                                            </div>
                                            <div class="d-flex justify-content-between p-1">
                                              <div class="d-flex flex-column text-capitalize">
                                                <span class="fontsize14 black60 proximanova ">Monthly Pricing</span>
                                                <span class="fontsize14 black proximanova" v-if="product.monthlyPricing">{{product.monthlyPricing}}</span>
                                              </div>
                                              <div class="d-flex flex-column text-capitalize">
                                                <span class="fontsize14 black60 proximanova ">Yearly Pricing</span>
                                                <span class="fontsize14 black proximanova" v-if="product.yearlyPricing">{{product.yearlyPricing}}</span>
                                              </div>
                                            </div>
                                            <div class="pt-2">
                                              <a  class="btn backgroundcolorblack white mouseoverwhite borderradius20 mouseoverbtn2" :href="product.productUrl" target="_blank"  id="search">
                                                  <span class="proximanova-semibold fontsize16">View Details</span>
                                              </a>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
import httpuserprofile from "@/js/http-userprofile.js";
import postvideomodal from '../../components/postVideoModal.vue'

export default{
    data(){
        return{

            pageloader:true,
            //details section
            businessAccountId : null,
            companyprofileId : null,
             // To store the existing videos
            productVideoData: [],
            limit: 10,
            offset: 0,
            instanceProductVideosList : [],
            ProductVideosList: [],
            isScrolled: false,
            noResults : false
        }
    },
    components: {
      postvideomodal,
    },
    methods:{

      //play and pause for product video
      playProductVideo : function(index, product) {
        var ind = 'productVideo'+index
        var productvideo = document.getElementById(ind)
        for(var i = 0; i < this.ProductVideosList.length; i++){
          if(i === index){
            if(!product.playingProductVideo){
                product.playingProductVideo = true;
                productvideo.play()
            }else{
                product.playingProductVideo = false;
                productvideo.pause()
            }
          }else{
            if(!this.ProductVideosList[i].replayVideo){
            this.ProductVideosList[i].playingProductVideo = false;
            
            let prevVideo = document.getElementById('productVideo'+i)
            prevVideo.pause()
            }
          }
        }
        productvideo.onended = function() {
          product.playingProductVideo = true;
          product.replayVideo = true;
          product.loadingVideo = false;
          var nextIndex = index + 1;
          var nextVideo = document.getElementById("companyProductVideoCardItem"+nextIndex);
          if(nextVideo){
            nextVideo.scrollIntoView()
          }
        }
        productvideo.oncanplay = function() {
          if(product.playingProductVideo){
            product.loadingVideo = false;
          }
        }
        productvideo.onwaiting = function() {
          if(product.playingProductVideo){
            product.loadingVideo = true;
          }
        }
      },
      replayfollowerVideo(index, product) {
            // console.log("replay video")
            this.ProductVideosList[index].replayVideo = false;
            this.ProductVideosList[index].playingProductVideo = false;
            this.playProductVideo(index, product)
        },
       // Get the list of product Videos
      getProductVideo(){
        httpuserprofile.get('/userprofile/getProductVideos?companyProfileId='+this.companyprofileId+'&limit='+this.limit+'&offset='+this.offset)
            .then((response) => {
              console.log(response);
              this.pageloader = false ;
              if(response.data && response.data.length > 0){
                response.data.forEach((ele,index) => {
                  ele.playingProductVideo = false;
                  ele.replayVideo = false;
                  ele.loadingVideo = false; 
                });
                this.instanceProductVideosList = response.data;
                this.ProductVideosList = this.ProductVideosList.concat(this.instanceProductVideosList);
                this.isScrolled = false
                this.noResults = false
              }else{
                  this.isScrolled = false
                  this.noResults = true
              }
        }).catch((e) => {
          console.log(e)
          this.pageloader = false
          this.isScrolled = false
        })
      },
      handlePageScroll () {
      // console.log('enter')
        if(!this.isScrolled){
            if (((window.innerHeight + window.scrollY +1) >= document.body.offsetHeight) && !this.noResults  ) {
              if(this.instanceProductVideosList.length > 9) {
                this.isScrolled = true;
                this.offset = this.offset+10;
                this.getProductVideo();
              }
            }
        }
    },

    },
    mounted(){
      this.businessAccountId = this.$session.get('business_account_id')
      this.companyprofileId = this.$session.get('company_profile_id')
      this.getProductVideo();
       window.addEventListener('scroll', this.handlePageScroll);
    },
    destroyed() {
    this.offset = 0;
    this.searchList = [];
    window.removeEventListener('scroll', this.handleScroll);
}
}
</script>
<style scoped>
.productvideocard{
	padding-left: 0;
	padding-right: 0;
	border-radius: 10px;
  }
.pausebtn{
  display: none;
}
.productvideocard:hover .pausebtn{
  display: block;
  margin-top: 7% !important;
}
   .card-img-overlay{
	padding: 0;
  }
  .playpausevideobtn{
    margin-top: 5% !important;
    margin-left: 48% !important;
    cursor: pointer;
  }
  .pageloader{
  width: 10%;
  margin-left: 45%;
  margin-top: 5%;
}
  .card{
    border: 1px solid #dddfe5;
    border-radius: 10px;
    background-color: #fff;
  }
  #productVideo{
  width: 100%;
}
#playvideobtn {
    display: block;
    margin-left: 47%;
    margin-top: 8% !important;
    margin-bottom: 5%;
    cursor: pointer;
}
.bottom{
	position: absolute;
	width: 100%;
	bottom: 0;
	left: 0;
  }
.aboutUsDetailsCard{
  border-radius: 10px;
}

.homevideoslist{
  padding: 0 !important;
}
.videocardbody {
    position: relative;
    width: 100%;
    height: 100%;
    background-attachment: scroll;
    overflow: hidden;
    z-index: 0;
}
.videocardbody video {
  background-color: #1F1F1F;
    min-width: 100%;
    width: 100%;
    min-height: 100%;
    position: relative;
    /* z-index: 1; */
    /* object-fit: fill; */
}
.videocardbody .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 2;
    /* background: rgba(31, 31, 31, .6); */
    /* background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%); */
    /* background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 50%); */
    opacity: 0.5;
    margin-top: -5px;
}


.productImg{
/* width:200px;*/
border-radius: 10px; 
/* height:250px; */
}
.productImgcard{
  /* background-color: #1f111f; */
  border-radius: 10px;
}
@media screen and (max-width : 500px) {
  .productImg{
width:100px;
}
}
</style>